import { render } from "./Authorgarden.vue?vue&type=template&id=4adaf4ca"
import script from "./Authorgarden.vue?vue&type=script&lang=js"
export * from "./Authorgarden.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__